module.exports = __webpack_public_path__ + "img/01_L2.40d31af9.svg";